


















import Vue, {VueConstructor} from 'vue'
import msgrsList from '@/components/Students/msgrsList.vue'
import disableMsgr from './disableMsgrButton.vue'
import {USER_ROLE_STUDAUTH} from '@/constants'
import Student from '@/models/Students/Student'
export default Vue.extend({
  props: {
    scope: {} as () => {student: Student},
    options: {}
  },
  components: {
    msgrsList,
    disableMsgr
  },
  data () {
    return {
      editMode: false
    }
  },
  methods: {
    async toggleEditMode () {
      try {
        await this.$store.dispatch('students/loadStudent', this.scope.student.getId())
        this.editMode = !this.editMode;
      } catch (error) {
        // @ts-ignore
        this.$message.error(this.$t('students.messenger.can_not_update_data'));
      }
    }
  },
  computed: {
    admin (): boolean {
      if (this.$store.state.user.user) {
        return this.$store.state.user.user.checkRole(USER_ROLE_STUDAUTH)
      }
      return false;
    }
  }
})
